import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface ProductPricingState {
  productPricingList?: any
  productPricingDetail?: any
  searchRQList?: any
}

const initialState: ProductPricingState = {
  productPricingList: {},
  productPricingDetail: {},
  searchRQList: {},
}

export const orderDucks = createSlice({
  name: 'rate',
  initialState,
  reducers: {

    getListProductPricing: (state: RootState, action: PayloadAction<any>) => {
      state.productPricingList = { loading: true, queryStr: action.payload }
    },
    getListProductPricingSuccess: (state, action: PayloadAction<any>) => {
      state.productPricingList = { loading: false, ...action.payload }
    },
    getListProductPricingFail: (state, action: PayloadAction<any>) => {
      state.productPricingList = { loading: false, ...action.payload }
    },

    getDetailProductPricing: (state: RootState, action: PayloadAction<any>) => {
      state.productPricingDetail = { loading: true, id: action.payload }
    },
    getDetailProductPricingSuccess: (state, action: PayloadAction<any>) => {
      state.productPricingDetail = { loading: false, ...action.payload }
    },
    getDetailProductPricingFail: (state, action: PayloadAction<any>) => {
      state.productPricingDetail = { loading: false, ...action.payload }
    },

    getListSearchRQ: (state: RootState, action: PayloadAction<any>) => {
      state.searchRQList = { loading: true, queryStr: action.payload }
    },
    getListSearchRQSuccess: (state, action: PayloadAction<any>) => {
      state.searchRQList = { loading: false, ...action.payload }
    },
    getListSearchRQFail: (state, action: PayloadAction<any>) => {
      state.searchRQList = { loading: false, ...action.payload }
    },
    
  },
})

// Action creators are generated for each case reducer function
export const {
  getListProductPricing,
  getListProductPricingSuccess,
  getListProductPricingFail,
  getDetailProductPricing,
  getDetailProductPricingSuccess,
  getDetailProductPricingFail,
  getListSearchRQ,
  getListSearchRQSuccess,
  getListSearchRQFail,
} = orderDucks.actions

export default orderDucks.reducer
